export default "__VITE_ASSET__BFVwtPDY__"